<template>
  <div class="pdv-footer">
    <div class="logo-content">
          <img src="/images/featured/nuevo-logo.svg" class="pdv-logo-new" alt="logo-new">
        </div>
    <div class="pdv-container">
      <div class="footer-container">
        
        <div class="info-content">
          <div class="flex-1">
            <div class="fragmen-footer">
              <a class="title-link">Otros sitios PDV</a>
              <a class="normal-link" href="https://www.preupdv.cl/alianzapdv/">Alianza PDV</a>
              <a class="normal-link" href="https://www.orientachile.cl/">Orienta Chile</a>
              <a class="normal-link" href="https://www.evolucionapdv.cl/">Evoluciona</a>
              <a class="normal-link" href="/documents/fichas-academicas.pdf">Fichas PDV</a>
              <!-- <a class="button-link-footer" href="https://www.preupdv.cl/alianzapdv/">
                Más información
              </a> -->
            </div>
          </div>
          <div class="flex-1">
            <div class="fragmen-footer">
              <a class="title-link">Quienes somos</a>
              <a class="normal-link" :href="ruleBook" target="_blank">Reglamento PDV</a>
            </div>
          </div>
          <div class="flex-1">
            <div class="fragmen-footer">
              <a class="title-link">Siguenos</a>
              <div class="redes-footer">
                <a class="normal-link" href="https://www.instagram.com/preupdv" target="_blank">
                  <img src="/images/featured/instagram.svg" class="mr-16" alt="icon-instagram">
                </a>
                <a class="normal-link" href="https://www.tiktok.com/@preupdv" target="_blank">
                  <img src="/images/featured/tiktok.svg" class="mr-16" alt="icon-tik">
                </a>
                <a class="normal-link" href="https://www.facebook.com/preupdv" target="_blank">
                  <img src="/images/featured/facebook.svg" class="mr-16" alt="icon-face">
                </a>
                <a class="normal-link" href="https://www.youtube.com/@PreuniversitarioPDV" target="_blank">
                  <img src="/images/featured/youtube.svg" class="mr-16" alt="icon-youtube">
                </a>
                <!--a class="normal-link" href="https://www.preupdv.cl/alianzapdv/">
                  <img src="/images/featured/simple-icons_x.svg" class="" alt="icon-simple-icons_x">
                </a-->                            
              </div>
            </div>
            <div class="fragmen-footer">
              <a class="title-link">Descargar app PDV</a>
              <div class="apps-footer">
                <a class="normal-link" href="https://apps.apple.com/ar/app/preu-pdv/id1095827339" target="_blank">
                  <img src="/images/featured/btn-apple.svg" alt="btn-apple">
                </a>
                <a class="normal-link" href="https://play.google.com/store/apps/details?id=com.PreuPDV" target="_blank">
                  <img src="/images/featured/btn-android.svg" alt="btn-android">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    backPackHeader: {
      default: true
    },

    hideFooterMobile: {
      default: false
    },
    hideFooter: {
      default: false
    }
  },
  computed: {
    ruleBook() {
      return process.env.VUE_APP_PDV_RULEBOOK;
    },
  },
  methods: {
    goToTop() {
      window.scrollTo({
        top:0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
};
</script>

<style scoped lang="scss">
  .pdv-footer{
    background: $neutralBlack;
    padding-bottom: 30px;
  }
  .footer-container{
    @media (max-width: 768px) {
      margin: 0 24px;
    }
    @media (min-width: 769px) {
      margin: 0 76px;
    }
  } 

  
    
  
  .logo-content{
    width:100%;
    height: 100px;
    margin-bottom: 15px;
    background-color: #FFD200;
    display: flex;
    justify-content: center;
  }
  .info-content{
    display: flex;
    @media (max-width: 768px) {
      flex-direction: column;
    }
    @media (min-width: 769px) {
      flex-direction: row;
    }
  }
  .fragmen-footer{
    display: flex;
    flex-direction: column;

    .title-link{
      color: $amarrillo50;
      font-size: 16;
      line-height: 24px;
      font-family: 'Poppins-Medium', sans-serif;
      margin-bottom: 16px;
      &:hover{
        color: $amarrillo50 !important;
      }
    }
    .normal-link{
      color: $neutralwhite !important;
      font-family: 'Poppins-Regular', sans-serif !important;
      font-size: 14px !important;
      line-height: 22px !important;
    }

    .redes-footer{
      display: flex;
      margin-top: 8px;
      margin-bottom: 32px;
    }

    .apps-footer{
      display: flex;
      margin-top: 8px;
      gap: 24px;
    }

  }

  .mr-16{
    margin-right: 16px;
  }

  .button-link-footer{
    margin-top: 21px;
    background: $colorTerciario !important;
    color: $neutralwhite !important;
    height: 32px !important;
    width: 50% !important;
    border-radius: 100px !important;
    display: flex ;
    justify-content: center;
    align-items: center;
    font-family: 'Poppins-Medium', sans-serif !important;
    font-size: 14px !important;
    line-height: 22px !important;
    padding: 0 16px;
    border: solid 2px $neutralwhite;
    @media (max-width: 768px) {
      margin-bottom: 32px;
    }
  }
</style>
